import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import FormSelect from '../../Form/FormSelect';
import NewTagOption from './NewTagOption';
// import NewTagForm from './NewTagForm';

const TagInput = ( {
	addNewTag,
	availableTags,
	// createdTags,
	// deleteNewTag,
	handleUpdate,
	tags,
	...props
} ) => {
	// const [ tagOptions, setTagOptions ] = useState( [] );

	// const tagExists = useCallback( value => availableTags.some( ( { text } ) => text.toLowerCase() === value.toLowerCase() ), [ availableTags ] );

	const newTagOption = useMemo( () => ( { // the form to create a new tag
		key: 0,
		content: <NewTagOption addTag={ addNewTag } />
	} ), [ addNewTag ] );

	const options = useMemo( () => [
		newTagOption,
		...availableTags
	], [
		availableTags,
		newTagOption
	] );

	// const optionContent = useCallback( ( text, id ) => {
	// 	const handleClick = e => {
	// 		e.stopPropagation();
	// 		deleteNewTag( id );
	// 	};

	// 	return (
	// 		<span>
	// 			<span>
	// 				{ text }
	// 			</span>
	// 			&nbsp;&nbsp;&nbsp;&nbsp;
	// 			<Icon
	// 				name="times"
	// 				onClick={ handleClick }
	// 			/>
	// 		</span>
	// 	);
	// }, [ deleteNewTag ] );

	// const mapTagOptions = useCallback( () => { // function to map options for tag dropdown
	// 	let createdTagOptions = [];

	// 	if ( createdTags.length ) {
	// 		createdTagOptions = createdTags.map( ( {
	// 			id,
	// 			text,
	// 			color
	// 		} ) => ( {
	// 			key: id,
	// 			content: optionContent( text, id ),
	// 			text,
	// 			value: id,
	// 			color,
	// 			icon: {
	// 				style: { color },
	// 				name: 'tags'
	// 			}
	// 		} ) );
	// 	}

	// 	const options = [
	// 		...availableTags,
	// 		...createdTagOptions
	// 	];

	// 	setTagOptions( [
	// 		NewTagOption,
	// 		...options
	// 	] );
	// }, [
	// 	availableTags,
	// 	createdTags,
	// 	NewTagOption,
	// 	optionContent
	// ] );

	// useEffect( () => {
	// 	mapTagOptions();
	// }, [ mapTagOptions ] );

	const renderLabel = ( {
		color,
		text
	} ) => ( {
		content: text,
		style: {
			backgroundColor: color,
			color: '#fff'
		}
	} );

	return (
		<>
			<FormSelect
				fieldLabel="Tags"
				multiple
				name="tags"
				onChange={ handleUpdate }
				options={ options }
				renderLabel={ renderLabel }
				value={ tags || [] }
				width={ 10 }
				{ ...props }
			/>
		</>
	);
};

TagInput.propTypes = {
	addNewTag: PropTypes.func.isRequired,
	availableTags: PropTypes.array,
	// createdTags: PropTypes.array.isRequired,
	// deleteNewTag: PropTypes.func.isRequired,
	handleUpdate: PropTypes.func.isRequired,
	tags: PropTypes.array.isRequired
};

export default TagInput;
